import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useLocalStorage } from 'hooks';
import { ThemeContext, initialState } from 'contexts/theme';
import RTL from './right-to-left';
import '../assets/css/index.scss';

import { One, Two } from 'config/theme';
import { useSettingsContext } from 'contexts/settings-context';

type MuiThemeProviderProps = {
    children: React.ReactNode;
};

// ** Declare Theme Provider
const MuiThemeProvider: React.FC<MuiThemeProviderProps> = ({ children }) => {
    const settings = useSettingsContext();

    const [modeConfig, setModeConfig] = useLocalStorage('theme-config', {
        ...initialState
    });

    const setMode = (mode) => {
        setModeConfig((prevState) => ({
            ...prevState,
            mode
        }));
    };
    let theme: any;
    if (modeConfig.mode === 'One') {
        theme = createTheme(One);
    } else if (modeConfig.mode === 'Two') {
        theme = createTheme(Two);
    }

    return (
        <ThemeContext.Provider value={{ ...modeConfig, setMode }}>
            <ThemeProvider theme={theme}>
                <RTL themeDirection={settings.themeDirection}>
                    <CssBaseline />
                    {children}
                </RTL>
            </ThemeProvider>
        </ThemeContext.Provider>
    );
};

export default MuiThemeProvider;
